<template>
    <v-input
        ref="input"
        :rules="rules"
        :disabled="disabled || (loading && loadingLock)"
        :readonly="readonly"
        :error-messages="errorMessages"
        :label="label"
        :class="`select-field ${required
            ? '--required'
            : ''
        }`"
        v-model="value"
        light
    >
        <v-autocomplete
            :value="loading && loadingLock ? null :value"
            :items="items"
            :item-text="selectValueName"
            :item-value="selectKeyName"
            :placeholder="loading && loadingLock ? loadingPlaceholder : placeholder"
            :loading="loading"
            :menu-props=" {
                overflowY: true,
                bottom: true
            }"
            browser-autocomplete="off"
            append-icon="bexsicon-menu-down"
            color="--field-font-color"
            single-line
            hide-details
            outline
            @input="e => $emit('input', e)"
            @change="e => $emit('change', e)"
        >
            <template slot="progress">
                <v-progress-linear
                    indeterminate
                    height="2"
                    class="select-field__loading"
                ></v-progress-linear>
            </template>
            <template slot="no-data">
                <span class="select-field__no-data">
                    {{ noDataLabel }}
                </span>
            </template>
        </v-autocomplete>
    </v-input>
</template>

<script>
export default {
  name: 'select-field',
  props: {
    value: {
      required: true
    },
    items: {
      type: Array,
      required: true
    },
    selectKeyName: {
      type: String,
      default: 'value'
    },
    selectValueName: {
      type: String,
      default: 'text'
    },
    rules: Array,
    label: String,
    disabled: Boolean,
    readonly: Boolean,
    required: Boolean,
    errorMessages: String,
    loading: Boolean,
    placeholder: String,
    loadingPlaceholder: String,
    loadingLock: {
      type: Boolean,
      default: true
    },
    noDataLabel: {
      type: String,
      default: 'Nenhum encontrado.'
    }
  }
};
</script>

<style lang="scss" >
.select-field {
  margin-top: 21px;
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
  position: relative;

  &__no-data {
    padding: 7px;
    font-size: 14px;
    color: var(--field-font-color);
  }

  &__loading {
    >>> .v-progress-linear__background {
      background-color: var(--brand-color) !important;
      border-color: var(--brand-color) !important;
    }

    >>> .v-progress-linear__bar__indeterminate {
      background-color: var(--brand-color) !important;
      border-color: var(--brand-color) !important;
    }
  }

  .v-label {
    position: absolute !important;
    top: -64%;
    font-size: 14px;
  }
  .v-select {
    .v-select__selection {
      color: var(--field-font-color);
    }
    & .v-input__slot {
      border: 1px solid #dcdcdc !important;
      min-height: 30px;
      height: 32.5px !important;
      border-radius: 5px;
      &:hover {
        border: 1px solid #dcdcdc !important;
      }
    }
  }

  .v-input__append-inner {
    margin-top: 4px !important;
  }
}
</style>



// WEBPACK FOOTER //
// ./src/components/fields/Select.vue